import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {!last && item.to ? (
                <Link to={item.to} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className={`whitespace-nowrap ${last ? "text-foreground-800 font-medium" : ""}`}>{item.label}</span>
              )}
              {!last && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}